import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_RAFFLES, res.data)
  })
)

export const save = async ({ commit }, obj) => {
  await services.store(obj).then(res => {
    commit(types.SET_RAFFLE, res.data.data)
    return res
  })
}
